var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 56,
    viewBox: "0 0 49 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#001c33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 20,
    strokeWidth: 3,
    d: "M44.69 2.37a2 2 0 012 2v47.377a2 2 0 01-2 2H3.6a2 2 0 01-2-2V4.37a2 2 0 012-2zM14.85 16.077h18.412M14.85 26.397h18.412"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#001c33",
    strokeLinecap: "round",
    strokeMiterlimit: 20,
    strokeWidth: 3,
    d: "M14.87 36.73h4.332"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OSIgaGVpZ2h0PSI1NiIgdmlld0JveD0iMCAwIDQ5IDU2Ij48Zz48Zz48ZyB0cmFuc2Zvcm09InJvdGF0ZSgtMjcwIDI0IDI4KSI+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAxYzMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIyMCIgc3Ryb2tlLXdpZHRoPSIzIiBkPSJNLTEuNjMgNy4zMWEyIDIgMCAwIDEgMi0yaDQ3LjM3N2EyIDIgMCAwIDEgMiAyVjQ4LjRhMiAyIDAgMCAxLTIgMkguMzdhMiAyIDAgMCAxLTItMnoiLz48L2c+PGc+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAxYzMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIyMCIgc3Ryb2tlLXdpZHRoPSIzIiBkPSJNMTQuODUgMTYuMDc3aDE4LjQxMiIvPjwvZz48Zz48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDFjMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjIwIiBzdHJva2Utd2lkdGg9IjMiIGQ9Ik0xNC44NSAyNi4zOTdoMTguNDEyIi8+PC9nPjwvZz48Zz48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDFjMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjIwIiBzdHJva2Utd2lkdGg9IjMiIGQ9Ik0xNC44NyAzNi43M2g0LjMzMiIvPjwvZz48L2c+PC9zdmc+";
export { SvgOrderBig as ReactComponent };